import { render, staticRenderFns } from "./DownloadInfoNew.vue?vue&type=template&id=42a1ac33&scoped=true&"
import script from "./DownloadInfoNew.vue?vue&type=script&lang=js&"
export * from "./DownloadInfoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a1ac33",
  null
  
)

export default component.exports